<template>
  <div class="about-page">
    <AboutHeader />

    <div class="about-body" v-if="loaded">
      <div class="doc-contents">
        <div class="content-holder">
          <h1>ABOUT WOTIVE</h1>
          <span class="date">Founded - 25th June 2021</span>
          <editor-content :editor="editorAbout" />
          <div class="img-holder">
            <img src="@/assets/luke-matt-image.png" />
            <span>Matt & Luke - Snowdon (Leg day), Rhyd Ddu path 2019</span>
          </div>

          <editor-content :editor="editorRest" />

          <div class="img-holder">
            <img src="@/assets/dbad-picture.png" />
          </div>

          <editor-content :editor="editorDBAD" />
          <div class="divider"></div>
        </div>
      </div>
    </div>

    <div class="loading" v-else></div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AboutHeader from '@/components/header/AboutHeader.vue';
import { formatDateTime } from '@/utils';
import { Editor, EditorContent } from 'tiptap';
import { getViewDocumentDetails } from '@/api/requests';
import TocHeading from '@/components/content_editor/TocHeading.js';
import {
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Strike,
  Underline,
  Image,
} from 'tiptap-extensions';

export default {
  name: 'About',

  data() {
    return {
      showSmallMenu: false,
      contents: '',
      editorAbout: null,
      editorRest: null,
      editorDBAD: null,
      headings: [],
      updatedAt: '',
      loaded: false,
    };
  },

  components: {
    Footer,
    EditorContent,
    AboutHeader,
  },

  mounted() {
    getViewDocumentDetails('about').then(response => {
      let data = response.data;
      let jsonData = JSON.parse(data.data);
      let stringBody = jsonData[0].body;
      this.updatedAt = jsonData[0].updated_at;
      this.contents = JSON.parse(stringBody);
      let contents = this.getAboutContents();
      this.editorAbout = new Editor({
        editable: false,
        content: contents['about'],
        extensions: [
          new BulletList(),
          new TocHeading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
        ],
      });
      
      this.editorRest = new Editor({
        editable: false,
        content: contents['rest'],
        extensions: [
          new BulletList(),
          new TocHeading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
        ],
      });

      this.editorDBAD = new Editor({
        editable: false,
        content: contents['dbad'],
        extensions: [
          new BulletList(),
          new TocHeading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
        ],
      });
      this.getPageOptions();
      this.loaded = true;
    }).catch(() => {
      // TODO errors
    });
  },

  methods: {
    toggleSmallMenu() {
      this.showSmallMenu = !this.showSmallMenu;
    },

    getHeadingTitle(heading) {
      return heading['content'][0]['text'];
    },

    getHeadingId(heading) {
      return '#' + heading['attrs']['id'];
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    getPageOptions() {
      this.contents['content'].forEach(content => {
        if ((content.type === 'heading') && (content.attrs.level === 2)) {
          this.headings.push(content);
        }
      });
    },

    getAboutContents() {
      let aboutContents = [];
      let restContents = [];
      let dbadContents = [];
      let rest = false;
      for (let i = 0; i < this.contents['content'].length; i++) {
        let currentContent = this.contents['content'][i];
        if (i > 0 && currentContent['type'] === 'heading') {
          rest = true;
        }
        if (i === this.contents['content'].length - 1) {
          dbadContents.push(currentContent);
        } else if (rest) {
          restContents.push(currentContent);
        } else {
          aboutContents.push(currentContent);
        }
      }

      return { 
        'about': {'type': 'doc', 'content': aboutContents },
        'rest': {'type': 'doc', 'content': restContents },
        'dbad': {'type': 'doc', 'content': dbadContents },
      };
    }
  },

  computed: {
    pageTitle() {
      if (this.type === 'about') {
        return 'about POLICY';
      } else {
        return 'TERMS OF SERVICE';
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/css/variables";
.about-page {
  background: #F4F7FA;
}

.content-holder {
  max-width: 800px;
  margin: auto;

  .date {
    color: $sec2;
    font-size: 18px;
    display: block;
    text-align: center;
    margin-bottom: $spacing-base*2;
  }

  .img-holder {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 60px;
    margin-top: $spacing-base*2;
    align-items: center;

    img {
      width: 300px;
    }

    span {
      font-size: 14px;
      color: $sec5;
    }
  }
}

@media all and (min-width: 650px) {
  .about-page {
    .about-header {
      display: block;
    }

    .about-header-mobile {
      display: none;
    }
  }
}

.loading {
  height: 100vh;
}

.about-body {
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1022px;
  margin: auto;

  h1 {
    text-transform: uppercase;
    text-align: center;
  }

  span {
    color: $sec2;
  }

  .doc-contents {
    display: flex;
    padding-top: $spacing-large;
    padding-bottom: $spacing-large;
  }

  .nav-holder {
    display: block;
    position: sticky; top:0;
    left: 0;
    width: 30%;
    align-self: flex-start;
    padding-right: $spacing-base;

    ol {
      color: $blue;
      font-size: 14px;
      padding: 0;
      padding-left: 0px;
      list-style: none;

      li {
        padding-bottom: $spacing-base;
      }

      a {
        color: $blue;
        text-decoration: none;
      }
    }
  }

  h1 {
    margin: 0;
    font-size: 48px;
    color: $sec0;
  }

  h2:not(:first-child):before{
    height: 80px;
    content: "";
    width: 100%;
    display: inline-block;
  }

  h2 {
    margin: 0;
    text-align: center;
    font-weight: 500;
    font-size: 36px;
    color: $sec2;
    text-transform: uppercase;
    padding-bottom: 16px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: $sec2;
  }

  p {
    font-size: 16px;
    color: $sec2;
    margin-top: 0;
  }

  .last-updated {
    text-align: center;
    margin: 0;
  }

  .divider {
    background-image: url(~@/assets/landing-page/divider.webp);
    max-width: 1200px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 40px;
  }
  
  ul {
    color: $sec2;
  }

  ol {
    color: $sec2;
  }

  .links {
    list-style: none;
    padding: 0;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;

    li {
      margin-bottom: $spacing-small;

      a {
        color: $blue;
        text-decoration: none;
      }
    }
  }
}

@media all and (max-width: 650px) {
  .about-body {
    .nav-holder {
      width: 100%;
      position: relative;
    }

    .doc-contents {
      display: block;
    }

    h1 {
      text-align: center;
      font-size: 36px;
    }

    span {
      text-align: center;
      display: block;
    }
  }
}
</style>